import React from 'react';
import PropTypes from 'prop-types';
import { CacheProvider } from '@emotion/react';
import ThemeTopLevelProvider from './ThemeTopLevelProvider';
import createEmotionCache from './createEmotionCache';

const emotionCache = createEmotionCache();
const theme = localStorage.getItem('theme');
const initTheme = theme === 'light' || theme === 'dark' ? theme : 'light';

export const wrapRootElement = ({ element }) =>
	<CacheProvider value={emotionCache}>
		<ThemeTopLevelProvider initTheme={initTheme}>
			{element}
		</ThemeTopLevelProvider>
	</CacheProvider>;

wrapRootElement.propTypes = {
	element: PropTypes.node
};
